import type { SelectorOption } from '../Components';

export const brandProfileUrls: SelectorOption[] = [
    {
        label: 'Sample document 1 - The Brick',
        value: 'https://api.sherbert.cimpress.io/v2/assets/TItjnuHAQNlaY9HQN-z_U~200?signature=97a2225de6f3101776847b425b3c2a32c7c38488',
    },
    {
        label: 'Sample document 2 - Sudbury Events Center',
        value: 'https://api.sherbert.cimpress.io/v2/assets/zvaHoj7XXkZX56WqkHWpY~200?signature=2d216cb09b0b8db18345a8b5460181e8fb1fa64b',
    },
    {
        label: 'Sample document 3 - Fabutan',
        value: 'https://api.sherbert.cimpress.io/v2/assets/x5mRYEj2thaCJWHyTINVl~200?signature=f0ec59c42556395a6f9cf2ffd56016fa05207f4e',
    },
    {
        label: 'Dee Graphiques',
        value: 'https://api.sherbert.cimpress.io/v2/assets/j99UYrmPn7-6STkWvIKvT~200?signature=1772c53d2a9e6edcf6dc17ffd17a732aee172d54',
    },
];
